import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LoginPage from "@/pages/LoginPage";
import OnboardingPage from "@/pages/OnboardingPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboard from "@/pages/AdminDashboard";

function ProtectedRoute({ children, adminOnly = false }) {
  const token = localStorage.getItem('bmm_token');
  const user = JSON.parse(localStorage.getItem('bmm_user') || '{}');

  if (!token) {
    return adminOnly ? <Navigate to="/admin" /> : <Navigate to="/" />;
  }
  if (adminOnly && !['admin', 'subadmin'].includes(user.role)) {
    return <Navigate to="/admin" />;
  }
  return children;
}

function App() {
  return (
    <div className="App min-h-screen bg-[#F8FAFC]">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/onboarding" element={
            <ProtectedRoute><OnboardingPage /></ProtectedRoute>
          } />
          <Route path="/admin" element={<AdminLoginPage />} />
          <Route path="/admin/dashboard" element={
            <ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>
          } />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
